/**
 * 予約完了時の処理モジュール
 * 予約完了時にローカルストレージからデータを削除する機能を提供
 */

// ローカルストレージキー（他のJSファイルと統一）
const STORAGE_KEY_PREFIX = 'fitspace_booking_';
const LAST_UPDATED_SUFFIX = '_last_updated';

/**
 * 予約完了処理の初期化
 * 完了ページで実行され、関連するローカルストレージデータを削除
 */
export const initialize = () => {
    // スペースIDを取得
    const mainElement = document.querySelector('main[data-finish-space-id]');
    if (!mainElement) return;

    const spaceId = mainElement.getAttribute('data-finish-space-id');
    if (!spaceId) return;

    // 予約データを削除
    clearStorageData(spaceId);
};

/**
 * 指定されたスペースIDに関連するローカルストレージデータを削除
 * @param {string} spaceId - スペースID
 */
const clearStorageData = (spaceId) => {
    try {
        // 予約データを削除
        const storageKey = `${STORAGE_KEY_PREFIX}${spaceId}`;
        localStorage.removeItem(storageKey);

        // 最終更新日時も削除
        const lastUpdatedKey = `${STORAGE_KEY_PREFIX}${spaceId}${LAST_UPDATED_SUFFIX}`;
        localStorage.removeItem(lastUpdatedKey);

        console.log(`予約完了により削除: ${storageKey}`);
    } catch (e) {
        console.error('ローカルストレージクリアエラー:', e);
    }
};